import {Divider} from '@/components/ui/divider/Divider'
import {ProjectFormNewProjectSection} from '@/features/projects/components/project-form/project-form-new-project-section/ProjectFormNewProjectSection'
import {ProjectFormPatientSection} from '@/features/projects/components/project-form/project-form-patient-section/ProjectFormPatientSection'
import {ProjectFormReferringSpecialistSection} from '@/features/projects/components/project-form/project-form-referring-specialist-section/ProjectFormReferringSpecialistSection'
import {ProjectReopeningReferenceSection} from '@/features/projects/components/project-form/project-reopening-reference-section/ProjectReopeningReferenceSection'
import {ProjectExtended} from '@/features/projects/types'
import {useOutletContext} from 'react-router-dom'

export const ProjectReopeningFormSections = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    return (
        <>
            <ProjectFormPatientSection showPatientSelect={false} patientId={project?.patientId} />
            <Divider direction="horizontal" />
            <ProjectReopeningReferenceSection isAllowed={project.status == 'closed'} />
            {project.status == 'closed' && (
                <>
                    <Divider direction="horizontal" />
                    <ProjectFormNewProjectSection editingOperation="variation" />
                    <Divider direction="horizontal" />
                    <ProjectFormReferringSpecialistSection />
                </>
            )}
        </>
    )
}
